import { setChartSettingsTableSettingsAction } from '../../../redux/slices/analyses';
import { useAppDispatch } from '../../../redux/hooks';
import { useChartContext } from '../../Chart/ChartContext';

export default (analysisId: string) => {
  const dispatch = useAppDispatch();
  const {
    settings: { chartSettings },
  } = useChartContext();
  const { searchTerm } = chartSettings.tableSettings;

  const onSearch = (term: string) => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          searchTerm: term,
        },
      }),
    );
  };

  return { searchTerm, onSearch };
};
